import { styled, keyframes } from '@mui/material/styles';

const copyAnimation = keyframes`
  0% {
    transform: scale(1);
  }
  30% {
    transform: scale(1.2);
  }
  50% {
    transform: rotate(20deg) scale(1.2);
  }
  60% {
    transform: rotate(-20deg) scale(1.2);
  }
  70% {
    transform: rotate(0deg) scale(1.2);
  }
  100% {
    transform: scale(1);
  }
`;

interface WrapperProps {
  $variant: 'button' | 'icon';
  $animationDuration: number;
  $isRecentlyCopied: boolean;
}

export const Wrapper = styled('div', {
  shouldForwardProp: prop => !['$variant', '$animationDuration', '$isRecentlyCopied'].includes(String(prop)),
})<WrapperProps>(({ theme, $variant, $animationDuration, $isRecentlyCopied }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: $variant === 'button' ? theme.spacing(1) : 0,
  ...($variant === 'button' && {
    cursor: 'pointer',
    '& .MuiIconButton-root': { opacity: 0, transition: 'opacity 0.2s ease-in-out' },
    '&:hover .MuiIconButton-root': { opacity: 1 },
  }),
  ...($isRecentlyCopied && $animationDuration > 0 && {
    '& .MuiIconButton-root svg': { animation: `${copyAnimation} ${$animationDuration}ms ease-out` },
  }),
  ...($variant === 'icon' && { '& .MuiIconButton-root': { opacity: 1 } }),
}));
